import React, { useEffect, useRef, createElement } from 'react';
interface ServiceArea {
  name: string;
  lat: number;
  lng: number;
}
interface ServiceAreaMapProps {
  serviceAreas: ServiceArea[];
}
const ServiceAreaMap: React.FC<ServiceAreaMapProps> = ({
  serviceAreas
}) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<any>(null);
  useEffect(() => {
    // Dynamically import Leaflet only on client-side
    const loadMap = async () => {
      if (typeof window !== 'undefined' && mapRef.current && !mapInstanceRef.current) {
        // Load Leaflet CSS
        const linkElement = document.createElement('link');
        linkElement.rel = 'stylesheet';
        linkElement.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        linkElement.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
        linkElement.crossOrigin = '';
        document.head.appendChild(linkElement);
        // Wait for CSS to load
        await new Promise(resolve => setTimeout(resolve, 100));
        // Import Leaflet
        const L = await import('leaflet');
        // Create map instance
        const map = L.map(mapRef.current).setView([26.3398, -81.7787], 9);
        // Add OpenStreetMap tiles
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);
        // Add markers for each service area
        serviceAreas.forEach(area => {
          L.marker([area.lat, area.lng]).addTo(map).bindPopup(area.name);
        });
        // Create a polygon for the service area
        const serviceAreaPoints = serviceAreas.map(area => [area.lat, area.lng]);
        L.polygon(serviceAreaPoints as any, {
          color: '#2563eb',
          fillColor: '#3b82f6',
          fillOpacity: 0.2
        }).addTo(map);
        mapInstanceRef.current = map;
      }
    };
    loadMap();
    // Cleanup function
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, [serviceAreas]);
  return <div ref={mapRef} className="w-full h-full rounded-lg" style={{
    background: '#e5e7eb'
  }} data-id="element-285" />;
};
export default ServiceAreaMap;